import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Login } from 'src/app/model/form/login';
import { Language } from 'src/app/model/language';
import { LANGUAGE_LIST } from 'src/app/model/mockup/language-mockup';
import { GlobalService } from 'src/app/service/global.service';
import { CustomValidator } from 'src/shared/custom-validator';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent implements OnInit{
  public form!: FormGroup;
  languageOptions: Language[]
  DEFAULT_LANGUAGE: Language;
  lastLanguage: Language;
  language: Language;
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private translocoService: TranslocoService,
    private globalService: GlobalService,
    
  ) {
    this.languageOptions = LANGUAGE_LIST as [];
    this.DEFAULT_LANGUAGE = this.languageOptions[0];
    this.language = this.DEFAULT_LANGUAGE;
    this.lastLanguage = this.DEFAULT_LANGUAGE;
  }

  ngOnInit(): void {
    sessionStorage.setItem('fromQr', 'true');
    this.createForm(new Login(this.getLanguage(null)));
    this.changeLanguage(this.getLanguage(null).name);
    this.refreshLanguageOptions();
    this.getLocation();
  }

  isExploding = false;

explode() {
  this.isExploding = false; // reset
  setTimeout(() => this.isExploding = true, 10); // ativa explosão
  setTimeout(() => this.isExploding = false, 2100); // limpa depois
}

getLanguage(lan: string | null): Language {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if (this.languageOptions[i].name === lan) {
        return this.languageOptions[i];
      }
    }
    return this.DEFAULT_LANGUAGE;
  }

    getLocation() {
    this.globalService.getGeoIp().subscribe((data) => {
      if (data.country_code === "BR") {
        this.form.get("language")?.setValue(this.languageOptions[0]);
      } else {
        this.form.get("language")?.setValue(this.languageOptions[1]);
      }
    });
  }

  refreshLanguageOptions() {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if (this.languageOptions[i].name === this.f.language.value.name)
        this.languageOptions[i].disabled = true;
      else this.languageOptions[i].disabled = false;
    }
  }

  fixLanguage() {
    this.language = this.f.language.value;
    if (this.lastLanguage !== this.language) {
      this.languageOptions
        .filter((opt) => opt.name === this.language.name)
        .map((cty) => (cty.disabled = true));
      this.languageOptions
        .filter((opt) => opt.name !== this.language.name)
        .map((cty) => (cty.disabled = false));

      this.lastLanguage = this.language;
      this.changeLanguage(this.language.name);
      sessionStorage.setItem("language", this.language.name);
    }
  }

  public changeLanguage(languageCode: string | null): void {
    if (languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  get f() {
    return this.form.controls;
  }

signUp() {
    sessionStorage.setItem("language", this.translocoService.getActiveLang());
    this.router.navigate(['/create-account']);
  }

login() {
    sessionStorage.setItem("language", this.translocoService.getActiveLang());
    this.router.navigate(['/login']);
  }

    createForm(login: Login) {
      this.form = this.formBuilder.group({
        email: [login.email, CustomValidator.getEmail()],
        password: [login.password, CustomValidator.getRequired()],
        language: [login.language],
      });
    }

}
